import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from '../../../icons/icon-provider';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { GigsumoConstants } from '../../../services/GigsumoConstants';
import pakageJson from '../../../../../package.json';

export interface ProfileMenuUser {
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
  userType?: string;       // raw enum (JOB_SEEKER, RECRUITER, …)
  userTypeLabel?: string;  // display label ("Manager", "Recruiter", …)
  gigsumoNo?: string | number;
  companyName?: string;
  photo?: string | null;
  plan?: string;           // e.g. "Free", "Starter", "Pro" — the user's current membership
  initials?: string;
  avatarBg?: string;
  avatarFg?: string;
  online?: boolean;
}

@Component({
  selector: 'app-profile-menu',
  standalone: true,
  imports: [CommonModule, DropdownComponent, NgIconComponent],
  providers: [provideIcons(APP_ICONS)],
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
})
export class ProfileMenuComponent {
  @Input() user: ProfileMenuUser = {};

  /** UI version — pulled from package.json, matching the login-page footer pattern. */
  public readonly versions: string = pakageJson.version;

  /** Highest plan ("ScaleX") — used to hide the "Upgrade Plan" footer pill
   *  when the user is already on the top tier. Mirrors user-badge.component.ts:33. */
  public readonly highestPlan: string = GigsumoConstants.HIGHEST_PLAN;

  @Output() toggled       = new EventEmitter<boolean>();
  @Output() viewProfile   = new EventEmitter<void>();
  @Output() openCompany   = new EventEmitter<void>();
  @Output() openAdmin     = new EventEmitter<void>();
  @Output() openPlans     = new EventEmitter<void>();
  @Output() openFaq       = new EventEmitter<void>();
  @Output() openSupport   = new EventEmitter<void>();
  @Output() logout        = new EventEmitter<void>();
  @Output() upgradePlan   = new EventEmitter<void>();

  @ViewChild('dd') dd!: DropdownComponent;

  // Emit the selected action and close the dropdown — mirrors apps-menu's
  // onItemClick pattern so a route click dismisses the panel like expected.
  onViewProfile()  { this.viewProfile.emit(); this.dd?.close(); }
  onOpenCompany()  { this.openCompany.emit(); this.dd?.close(); }
  onOpenAdmin()    { this.openAdmin.emit();   this.dd?.close(); }
  onOpenPlans()    { this.openPlans.emit();   this.dd?.close(); }
  onOpenFaq()      { this.openFaq.emit();     this.dd?.close(); }
  onOpenSupport()  { this.openSupport.emit(); this.dd?.close(); }
  onLogout()       { this.logout.emit();      this.dd?.close(); }
  onUpgradePlan()  { this.upgradePlan.emit(); this.dd?.close(); }
}
